/* Local dependencies */
import { ConsigneeProfile } from '../../../consignee-profiles/redux/reducer';

export enum CreateConsigneeGoodsSpecificationActionTypes {
  SET_CREATE_CONSIGNEE_GOOD_FIELD = 'SET_CREATE_CONSIGNEE_GOOD_FIELD',
  ADD_COLUMN_TO_TABLE = 'ADD_COLUMN_TO_TABLE',
  ADD_COLUMN_TO_SIDEBAR = 'ADD_COLUMN_TO_SIDEBAR',
  CREATE_CONSIGNEE_GOODS_SPEC_REQUEST = 'CREATE_CONSIGNEE_GOODS_SPEC_REQUEST',
  CREATE_CONSIGNEE_GOODS_SPEC_SUCCESS = 'CREATE_CONSIGNEE_GOODS_SPEC_SUCCESS',
  CREATE_CONSIGNEE_GOODS_SPEC_ERROR = 'CREATE_CONSIGNEE_GOODS_SPEC_ERROR',
  CREATE_CONSIGNEE_GOODS_SPEC_RESET = 'CREATE_CONSIGNEE_GOODS_SPEC_RESET',
}

export enum Specification {
  DEFAULT = 'default',
  SUM = 'sum',
  GROUP = 'group',
}

export interface Section {
  name: string;
  values: string[];
}

export interface FileData {
  [key: string]: string | number | any[];
}

export interface Column {
  id: string;
  fileName: string;
  columnName: string;
  specification: Specification;
  position?: number;
  values?: string[] | number[];
}

export interface SpecificationRef {
  exportFile: {
    url: string;
  };
}

export type Sections = Section[];

export type CreateConsigneeGoodsSpecificationValue =
  | Sections
  | FileData
  | ConsigneeProfile
  | string
  | null;

export type SourceItem = { [key: string]: number | string };
export type SourceArray = SourceItem[];

export type ColumnsToGroup = string[];
export type ColumnsToSum = string[];

export type ConsigneeProfileInput = {
  id: string;
  name: string;
};

export type CreateConsigneeGoodSpecificationInput = {
  file: string;
  columnsToGroup: ColumnsToGroup;
  columnsToSum?: ColumnsToSum;
  consigneeProfile: ConsigneeProfileInput;
};

export interface SetCreateConsigneeGoodField {
  type: CreateConsigneeGoodsSpecificationActionTypes.SET_CREATE_CONSIGNEE_GOOD_FIELD;
  field: string;
  value: CreateConsigneeGoodsSpecificationValue;
  childField?: string;
}

export interface AddColumnToTable {
  type: CreateConsigneeGoodsSpecificationActionTypes.ADD_COLUMN_TO_TABLE;
  column: Column;
}

export interface AddColumnToSidebar {
  type: CreateConsigneeGoodsSpecificationActionTypes.ADD_COLUMN_TO_SIDEBAR;
  column: Column;
}

export interface CreateConsigneeGoodsSpecRequest {
  type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_REQUEST;
  input: CreateConsigneeGoodSpecificationInput;
}

export interface CreateConsigneeGoodsSpecSuccess {
  type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_SUCCESS;
  payload: SpecificationRef;
}

export interface CreateConsigneeGoodsSpecError {
  type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_ERROR;
  error: Error;
}

export interface CreateConsigneeGoodsSpecResetError {
  type: CreateConsigneeGoodsSpecificationActionTypes.CREATE_CONSIGNEE_GOODS_SPEC_RESET;
}

export type CreateConsigneeGoodsSpecificationAction =
  | SetCreateConsigneeGoodField
  | AddColumnToTable
  | AddColumnToSidebar
  | CreateConsigneeGoodsSpecRequest
  | CreateConsigneeGoodsSpecSuccess
  | CreateConsigneeGoodsSpecError
  | CreateConsigneeGoodsSpecResetError;
